import * as mixpanel from 'mixpanel-figma';
import posthog from 'posthog-js';

export function trackEvent(eventName, properties) {
  mixpanel.track(eventName, properties);
}

export function identifyUser(userId, email) {
  mixpanel.identify(userId);

  if (userId) {
    posthog.identify(userId, { email });
  }
}
